import React, { useEffect, useState } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import Spinner from '@atlaskit/spinner';

// To avoid a flash of content, only show the loading spinner if the page load
// is taking unreasonably long
export const SPINNER_APPEARANCE_DELAY = 2000;

const SpinnerContainerStyles = xcss({
	position: 'fixed',
	// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
	top: '50%',
	// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
	left: '50%',
	transform: 'translate(-50%, -50%)',
});

export const ShowSpinnerAfterDelay = () => {
	const [isTooSoonToShowSpinner, setIsTooSoonToShowSpinner] = useState(true);
	useEffect(() => {
		void setTimeout(() => {
			setIsTooSoonToShowSpinner(false);
		}, SPINNER_APPEARANCE_DELAY);
	}, []);
	return isTooSoonToShowSpinner ? null : (
		<Box xcss={SpinnerContainerStyles} role="progressbar">
			<Spinner size="large" />
		</Box>
	);
};
